import { getParams } from '@/utils/params';

interface WellnessData {
  [key: string]: string | number | undefined;
  designId?: string;
  position?: number;
  search?: string;
  categoryId?: string;
  application?: string;
  version?: string;
  compositionId?: string;
}

const wellnessCache = new Set<string>();

export const trackWellness = (action: string, data: WellnessData = {}) => {
  // disable locally
  if (!ENV.enableWellness) {
    return;
  }

  const params = getParams();
  let cacheId = action;

  Object.entries(data).forEach(([key, value]) => {
    cacheId += `_${key}-${String(value)}`;
  });

  if (!wellnessCache.has(cacheId)) {
    wellnessCache.add(cacheId);

    const payload = { ...data };

    payload.locale = params.locale;
    payload.localTime = Date.now().toString();
    payload.platform = params.platform.toLowerCase();
    payload.context = params.context;
    payload.contextId = params.contextId;
    payload.application = params.application;
    payload.version = params.version;

    const queries = Object.entries(payload).reduce<string[]>((ret, [key, value]) => {
      if (!value) {
        return ret;
      }
      ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`);
      return ret;
    }, []);

    const host = window.location.hostname.replace('designer.', 'www.');
    const url = `//${host}/shopData/wellness/${action}?${queries.join('&')}`;

    const img = new Image();
    img.src = url;
  }
};
